// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Carousel_placeholder__vQYqe","slidata_wrapper":"Carousel_slidata_wrapper__vIOBP","image":"Carousel_image__yPlRf"};